<template>
  <form-group class="ma-0 pa-0 pt-3">
    <v-tabs
      v-model="tabs"
      vertical
    >
      <v-tab>
        Informações do produto
      </v-tab>

      <v-tab>
        Marca
      </v-tab>

      <v-tab>
        Precificação
      </v-tab>

      <v-tab v-if="displayTab">
        {{ typeProduct }}
      </v-tab>

      <v-tabs-items
        v-model="tabs"
        vertical
      >
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <produto-info
                :payload="value"
              />
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <form-group>
                <marca-regional
                  :payload="value"
                  :attrs-marca="{ disabled: true }"
                  :attrs-regional="{ disabled: true }"
                />
              </form-group>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <form-group>
                <range-valores-produto :payload="value" />
              </form-group>
              <produto-grade-valores
                v-if="isGrade"
                ref="grade"
                v-model="value"
              />
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <gift-card
                v-if="isGiftCard"
                :payload="payload"
              />
              <produto-boleto
                v-if="isConfInvoice"
                :payload="payload"
              />
              <pagamento-conta-boleto
                v-if="isAccount"
                :payload="payload"
              />
              <produto-ted-tef
                v-if="isTedTef"
                :payload="payload"
              />
              <produto-trasnferencia
                v-if="isTransfer"
                :payload="payload"
              />
              <chip-category
                v-if="isCp"
                v-model="payload"
              />
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </form-group>
</template>

<script>
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import ProductCategory from '@/app/arch/enums/ProductCategory';
import ChipCategory from 'Modules/contacard/produto/product/components/displays/ChipCategory.vue';
import GiftCard from '../displays/GiftCard.vue';
import ProdutoBoleto from '../displays/ProdutoBoleto.vue';
import PagamentoContaBoleto from '../displays/PagamentoContaBoleto.vue';
import ProdutoTedTef from '../displays/ProdutoTedTef.vue';
import ProdutoTrasnferencia from '../displays/ProdutoTrasnferencia.vue';
import ProdutoInfo from '../displays/ProdutoInfo.vue';
import MarcaRegional from '../inputs/MarcaRegional.vue';
import RangeValoresProduto from '../inputs/RangeValoresProduto.vue';
import ProdutoGradeValores from '../displays/ProdutoGradeValores.vue';

export default {
  name: 'EditProductContentBody',
  components: {
    FormGroup,
    GiftCard,
    ProdutoBoleto,
    PagamentoContaBoleto,
    ProdutoTedTef,
    ProdutoTrasnferencia,
    ProdutoInfo,
    MarcaRegional,
    RangeValoresProduto,
    ProdutoGradeValores,
    ChipCategory,
  },
  props: {
    value: {
      type: Object,
      required: true,
      default() {
        return {
          produtoServicoCategoria: '',
          tipoValorProduto: '',
        };
      },
    },
  },
  data: () => ({
    tabs: null,
    categories: ProductCategory,
  }),
  computed: {
    payload() {
      return this.value;
    },
    isGrade() {
      return this.payload.tipoValorProduto === 'GRADE';
    },
    getCategory() {
      return this.payload.produtoServicoCategoria || this.$route.params.category;
    },
    isGiftCard() {
      return this.getCategory === 'GIFTCARD';
    },
    isConfInvoice() {
      return this.getCategory === 'BOLETO';
    },
    isAccount() {
      return this.getCategory === 'PAGAMENTO_CONTA_BOLETO';
    },
    isTedTef() {
      return this.getCategory === 'TRANSFERENCIA_ENTRE_CONTA';
    },
    isTransfer() {
      return this.getCategory === 'RECARGA_TRANSPORTE';
    },
    isRO() {
      return this.getCategory === 'RECARGA_ONLINE';
    },
    isCp() {
      return this.getCategory === 'CHIP';
    },
    displayTab() {
      return this.isGiftCard || this.isConfInvoice
      || this.isAccount || this.isTransfer || this.isTedTef
      || this.isCp;
    },
    typeProduct() {
      const category = this.categories.find(
        (item) => item.value === this.getCategory,
      );

      return category ? category.text : this.getCategory;
    },
  },
};
</script>
